import {
    ALL_GUEST_COMMENT_RECENT_FAIL,
    ALL_GUEST_COMMENT_RECENT_REQUEST,
    ALL_GUEST_COMMENT_RECENT_RESET,
    ALL_GUEST_COMMENT_RECENT_SUCCESS,
    GUEST_COMMENT_PAST_FAIL,
    GUEST_COMMENT_PAST_REQUEST,
    GUEST_COMMENT_PAST_RESET,
    GUEST_COMMENT_PAST_SUCCESS,
    GUEST_COMMENT_TODAY_FAIL,
    GUEST_COMMENT_TODAY_REQUEST,
    GUEST_COMMENT_TODAY_RESET,
    GUEST_COMMENT_TODAY_SUCCESS,
    GUEST_USER_COMMENT_INSERT_FAIL,
    GUEST_USER_COMMENT_INSERT_REQUEST,
    GUEST_USER_COMMENT_INSERT_RESET,
    GUEST_USER_COMMENT_INSERT_SUCCESS,
    GUEST_USER_DETAIL_FAIL,
    GUEST_USER_DETAIL_REQUEST,
    GUEST_USER_DETAIL_RESET,
    GUEST_USER_DETAIL_SUCCESS,
    GUEST_USER_LOGIN_FAIL,
    GUEST_USER_LOGIN_REQUEST,
    GUEST_USER_LOGIN_RESET,
    GUEST_USER_LOGIN_SUCCESS
} from "../constants/userConstants";

export const guestUserLoginReducer = (state = { userInfo: [] }, action) => {
    switch (action.type) {
        case GUEST_USER_LOGIN_REQUEST:
            return { loading: true };
        case GUEST_USER_LOGIN_SUCCESS:
            return { loading: false, userInfo: action.payload }
        case GUEST_USER_LOGIN_FAIL:
            return { loading: false, error: action.payload }
        case GUEST_USER_LOGIN_RESET:
            return { loading: false, userInfo: [] }
        default:
            return state;
    }
}

export const guestUserDetailReducer = (state = { userDetails: [] }, action) => {
    switch (action.type) {
        case GUEST_USER_DETAIL_REQUEST:
            return { loading: true };
        case GUEST_USER_DETAIL_SUCCESS:
            return { loading: false, userDetails: action.payload }
        case GUEST_USER_DETAIL_FAIL:
            return { loading: false, error: action.payload }
        case GUEST_USER_DETAIL_RESET:
            return { loading: false, userDetails: [] }
        default:
            return state;
    }
}

export const guestUserInsertReducer = (state = { }, action) => {
    switch (action.type) {
        case GUEST_USER_COMMENT_INSERT_REQUEST:
            return { loading: true };
        case GUEST_USER_COMMENT_INSERT_SUCCESS:
            return { loading: false, success: action.payload }
        case GUEST_USER_COMMENT_INSERT_FAIL:
            return { loading: false, error: action.payload }
        case GUEST_USER_COMMENT_INSERT_RESET:
            return { loading: false, success: '' }
        default:
            return state;
    }
}

export const guestAllCommentsReducer = (state = { allRecentComments : [] }, action) => {
    switch (action.type) {
        case ALL_GUEST_COMMENT_RECENT_REQUEST:
            return { loading: true };
        case ALL_GUEST_COMMENT_RECENT_SUCCESS:
            return { loading: false, allRecentComments: action.payload }
        case ALL_GUEST_COMMENT_RECENT_FAIL:
            return { loading: false, error: action.payload }
        case ALL_GUEST_COMMENT_RECENT_RESET:
            return { loading: false, allRecentComments: [] }
        default:
            return state;
    }
}

export const guestTodayCommentsReducer = (state = { todayComments:[] }, action) => {
    switch (action.type) {
        case GUEST_COMMENT_TODAY_REQUEST:
            return { loading: true };
        case GUEST_COMMENT_TODAY_SUCCESS:
            return { loading: false, todayComments: action.payload }
        case GUEST_COMMENT_TODAY_FAIL:
            return { loading: false, error: action.payload }
        case GUEST_COMMENT_TODAY_RESET:
            return { loading: false, todayComments:[] }
        default:
            return state;
    }
}

export const guestPastCommentsReducer = (state = { pastComments:[] }, action) => {
    switch (action.type) {
        case GUEST_COMMENT_PAST_REQUEST:
            return { loading: true };
        case GUEST_COMMENT_PAST_SUCCESS:
            return { loading: false, pastComments: action.payload }
        case GUEST_COMMENT_PAST_FAIL:
            return { loading: false, error: action.payload }
        case GUEST_COMMENT_PAST_RESET:
            return { loading: false, pastComments:[] }
        default:
            return state;
    }
}

